// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SliderConfig_wrapper__q1FYg","flexRow":"SliderConfig_flexRow__2wRPR","input":"SliderConfig_input__ZFKbX","text":"SliderConfig_text__kKeTp"};